module.exports = __webpack_public_path__ + "img/17-467d51.png";